const protocolRe = /http(s)?:/

const removeProtocol = function (t = ''): string {
  return t.replace(protocolRe, '')
}

/**
 * @description Port of Shopify `getSizedImageUrl` utility
 */
export const getSizedImageUrl = function (
  url: string | null | undefined,
  size?: string
): string | null {
  if (url == null) {
    return null
  }

  if (!(url.includes(window.Shopify.store) || url.includes(window.Shopify.cdnHost) || url.includes('/cdn/shop/files/') || url.includes('cdn.shopify.com'))) {
    return url
  }

  if (size == null) {
    return url
  }

  if (size === 'master') {
    return removeProtocol(url)
  }

  const cleanUrl = removeProtocol(url)

  const sizedUrl = cleanUrl.replace(
    /(.+)(_)((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})([_.@].+)/,
    function (_, head, underscore, _oldSize, tail) {
      return head + underscore + size + tail
    }
  )

  if (sizedUrl !== cleanUrl) return sizedUrl

  return cleanUrl.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return '_' + size + match
  })
}
